import { __decorate } from "tslib";
import TariffList from '@/types/Tariff/TariffList';
import { Component, Vue } from 'vue-property-decorator';
let UserTariffDialog = class UserTariffDialog extends Vue {
    initialLoad() {
        Promise.all([this.$store.dispatch('adminGetUserTariffsAsync', this.$props.user.userId), this.$store.dispatch('loadGlobalTariffsAsync')]).then((values) => {
            this.$data.userTariffs = new TariffList(values[0].data); //sets the interns tariffs
            this.$data.globalTariffs = new TariffList(values[1].data); // sets the global tariffs     
            //set the missing   
            this.$data.loading = false;
        }).catch((err) => {
            window.errorHandler.logError(err, 'components/modals/userTariffDialog.vue - initalLoad');
        }).then(() => { this.$data.loading = false; });
    }
    loadUserTariffs() {
        const userId = this.$props.user.userId;
        this.$store.dispatch('adminGetUserTariffsAsync', userId).then((result) => {
            this.$data.userTariffs = new TariffList(result.data); //sets the user tariffs
        }).catch((err) => {
            window.errorHandler.logError(err, 'components/InternsEditor.vue - loadUserTariffs');
        }).then(() => { this.$data.loading = false; });
    }
    loadGlobalTariffs() {
        this.$store.dispatch('loadGlobalTariffsAsync').then((result) => {
            this.$data.globalTariffs = new TariffList(result.data); // sets the global tariffs 
        }).catch((err) => {
            window.errorHandler.logError(err, 'components/InternsEditor.vue - loadInterns');
        });
    }
    //adds or enables the tariff for the user
    addTariffToUser(tariffData) {
        this.$data.tariffTableLoading = true;
        console.log(tariffData);
        this.$store.dispatch('adminAddUserTariffAsync', { userId: this.$props.user.userId, tariffId: tariffData.id }).then((result) => {
            this.loadUserTariffs();
            this.$store.dispatch('ToastMessage', { type: 'any', message: 'The Tariff [' + tariffData.customerName + '-' + tariffData.name + '] has been enabled for ' + this.$props.user.firstName });
        }).catch((err) => {
            window.errorHandler.logError(err, 'components/modals/UserTariffDialog.vue - addTariffToUser');
        }).then(() => {
            this.$data.tariffTableLoading = false;
        });
    }
    //disables or removes the tariff fdrom the user
    removeTariffFromUser(tariffData) {
        this.$store.dispatch('adminRemoveUserTariffAsync', { userId: this.$props.user.userId, tariffId: tariffData.id }).then((result) => {
            this.loadUserTariffs();
            this.$store.dispatch('ToastMessage', { type: 'any', message: 'The Tariff [' + tariffData.customerName + '-' + tariffData.name + '] has been disabled for ' + this.$props.user.firstName });
        }).catch((err) => {
            window.errorHandler.logError(err, 'components/modals/UserTariffDialog.vue - addTariffToUser');
        }).then(() => {
            this.$data.tariffTableLoading = false;
        });
    }
};
UserTariffDialog = __decorate([
    Component({
        data() {
            return {
                trueVal: true,
                tariffHeaders: [
                    { text: 'Customer', value: 'customerName' },
                    { text: 'Name', value: 'name' },
                    { text: 'Delete', value: 'delete' },
                ],
                theme: this.$store.getters.getTheme,
                modals: { tariff: false, },
                loading: false,
                tariffTableLoading: false,
                tariffFilter: null,
                missingTariffs: [],
                tariffData: null,
                userTariffs: null,
                globalTariffs: null,
            };
        },
        props: ['user'],
        mounted() {
            this.$data.loading = true;
            this.initialLoad();
        },
        computed: {
            showModal: {
                get() {
                    return this.$data.trueVal;
                },
                set(newValue) {
                    console.log("setting new vlaue", newValue);
                    this.$data.trueVal = newValue;
                    if (this.$data.trueVal === false) {
                        this.$emit('close'); //we need to send the close event if the dialog is closed by clicking outside rather than on the button
                    }
                }
            },
            calculateMissingTariffs: {
                get() {
                    if (this.$data.userTariffs !== undefined) {
                        this.$data.missingTariffs = [];
                        this.$data.globalTariffs.tariffs.forEach((tariff) => {
                            if (this.$data.userTariffs.getTariffFromId(tariff.id) === undefined) {
                                this.$data.missingTariffs.push(tariff);
                            }
                        });
                        return this.$data.missingTariffs;
                    }
                }
            },
        },
        methods: {
            close() {
                this.$emit('close');
            }
        }
    })
], UserTariffDialog);
export default UserTariffDialog;
